import { addDays, parse, parseISO, subDays } from 'date-fns';
import {
  TENANCY_END_DATE_TYPE,
  TENANCY_LENGTH_TYPE,
  TENANCY_START_DATE_TYPE,
} from '~graphql-types';

export const DATE_FORMAT = 'EEE, d MMM yyyy';

export const getTenancyOptionRangeDayPickerDisabledDaysBefore = (
  parseISOStartDate,
  parseISOEndDate,
  endDateType,
  tenancyLength,
  tenancyLengthType
) => {
  if (endDateType === TENANCY_END_DATE_TYPE.EQ && tenancyLengthType === TENANCY_LENGTH_TYPE.LE) {
    return subDays(parseISOEndDate, tenancyLength);
  }

  return parseISOStartDate;
};

export const getTenancyOptionRangeDayPickerDisabledDaysAfter = (
  parseISOStartDate,
  startDateType,
  parseISOEndDate,
  endDateType,
  tenancyLength,
  tenancyLengthType
) => {
  if (
    startDateType === TENANCY_START_DATE_TYPE.EQ &&
    tenancyLengthType === TENANCY_LENGTH_TYPE.LE
  ) {
    return addDays(parseISOStartDate, tenancyLength);
  }

  if (endDateType === TENANCY_END_DATE_TYPE.EQ) {
    return addDays(parseISOEndDate, -1);
  }

  return parseISOEndDate;
};

export const getTenancyOptionRangeDayPickerDisabledDays = ({
  tenancyOption,
  selectedStartDate,
  selectedEndDate,
}) => {
  const {
    startDate,
    startDateType,
    endDate,
    endDateType,
    tenancyLength,
    tenancyLengthType,
  } = tenancyOption;
  const parseISOStartDate = parseISO(startDate);
  const parseISOEndDate = parseISO(endDate);
  const disabledBefore = getTenancyOptionRangeDayPickerDisabledDaysBefore(
    parseISOStartDate,
    parseISOEndDate,
    endDateType,
    tenancyLength,
    tenancyLengthType
  );
  const disabledAfter = getTenancyOptionRangeDayPickerDisabledDaysAfter(
    parseISOStartDate,
    startDateType,
    parseISOEndDate,
    endDateType,
    tenancyLength,
    tenancyLengthType
  );
  const disabledDaysRules = [{ before: disabledBefore }, { after: disabledAfter }];
  const isEQStartDateType = startDateType === TENANCY_START_DATE_TYPE.EQ;
  const isEQEndDateType = endDateType === TENANCY_END_DATE_TYPE.EQ;
  const isLETenancyLengthType = tenancyLengthType === TENANCY_LENGTH_TYPE.LE;
  const isGETenancyLengthType = tenancyLengthType === TENANCY_LENGTH_TYPE.GE;
  const isEQTenancyLengthType = tenancyLengthType === TENANCY_LENGTH_TYPE.EQ;
  if (isEQStartDateType && !selectedStartDate) {
    disabledDaysRules.push({
      from: addDays(parseISOStartDate, 1),
      to: parseISOEndDate,
    });

    return disabledDaysRules;
  }

  if (isEQStartDateType && selectedStartDate) {
    disabledDaysRules.push({
      from: isLETenancyLengthType
        ? addDays(parseISOStartDate, tenancyLength + 1)
        : parseISOStartDate,
      to: isLETenancyLengthType ? parseISOEndDate : addDays(parseISOStartDate, tenancyLength - 1),
    });
    return disabledDaysRules;
  }

  if (isEQEndDateType) {
    disabledDaysRules.push({
      from: isLETenancyLengthType
        ? parseISOStartDate
        : addDays(parseISOEndDate, -(tenancyLength - 1)),
      to: isLETenancyLengthType ? addDays(parseISOEndDate, -(tenancyLength + 1)) : parseISOEndDate,
    });

    return disabledDaysRules;
  }

  if (isLETenancyLengthType && selectedStartDate && !selectedEndDate) {
    const parseRangeDateFrom = parse(selectedStartDate, DATE_FORMAT, new Date());

    const tenancyLengthDisabledDaysBeforeSeletedDate = {
      from: parseISOStartDate,
      to: subDays(parseRangeDateFrom, tenancyLength + 1),
    };
    const tenancyLengthDisabledDaysAfterSeletedDate = {
      from: addDays(parseRangeDateFrom, tenancyLength + 1),
      to: parseISOEndDate,
    };

    disabledDaysRules.push(
      tenancyLengthDisabledDaysBeforeSeletedDate,
      tenancyLengthDisabledDaysAfterSeletedDate
    );
    return disabledDaysRules;
  }

  if (isEQTenancyLengthType) {
    disabledDaysRules.push({
      from: addDays(parseISOEndDate, -tenancyLength),
      to: parseISOEndDate,
    });
    return disabledDaysRules;
  }

  if (isGETenancyLengthType && !selectedStartDate) {
    disabledDaysRules.push({
      from: subDays(parseISOEndDate, tenancyLength - 1),
      to: parseISOEndDate,
    });
    return disabledDaysRules;
  }

  if (isGETenancyLengthType && selectedStartDate && !selectedEndDate) {
    const parseRangeDateFrom = parse(selectedStartDate, DATE_FORMAT, new Date());

    const tenancyLengthDisabledDaysBeforeSeletedDate = {
      from: parseRangeDateFrom,
      to: subDays(parseRangeDateFrom, tenancyLength - 1),
    };
    const tenancyLengthDisabledDaysAfterSeletedDate = {
      from: parseRangeDateFrom,
      to: addDays(parseRangeDateFrom, tenancyLength - 1),
    };

    disabledDaysRules.push(
      tenancyLengthDisabledDaysBeforeSeletedDate,
      tenancyLengthDisabledDaysAfterSeletedDate
    );
    return disabledDaysRules;
  }

  return disabledDaysRules;
};
